import { mainApiAxios as axios } from '@/plugins/axios'


export default {

    listDictionary() {
        return axios.get('dictionary')
    },

    updateDictionary(dictionaryId, dictionaryObj) {
        return axios.post(`dictionary/update/${dictionaryId}`, dictionaryObj)
    },

    addDictionary(dictionaryObj) {
        return axios.post('dictionary', dictionaryObj)
    },

    deleteDictionary(dictionaryId) {
        return axios.post(`dictionary/${dictionaryId}`)
    }
}